import React from "react";

const PrimaryButton = ({ children, className, ...props }) => {
  return (
    <button
      className={`px-8 py-1  text-sm bg-blue-800 text-white rounded-md
      ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
